import { type ProductVariantFieldsFragment } from '../../__generated__/graphql-client-types';
import { type PdpProductFamily } from '../../types/product.types';

export const getDatalayerForProductPage = (product: PdpProductFamily, variant?: ProductVariantFieldsFragment, overrides: object = {}) => {
	return {
		...overrides,
		selectedFinish: {
			priceValue: variant?.priceInfo?.current,
			uniqueId: variant?.id,
			title: variant?.title,
			sale: variant?.sales,
			modelNumber: variant?.modelNumber,
			shippingClassifications: variant?.shippingClassifications,
			isOutOfStock: variant?.isOutOfStock
		},
		manufacturer: product?.brandInfo?.name,
		product: {
			businessCategory: product?.businessCategory?.name,
			baseCategory: product?.baseCategory?.name,
			application: product?.application,
			type: product?.type,
			title: product?.title,
			hasRecommendedOptions: product?.hasRecommendedOptions
		},
		collection: product?.collection?.name || '',
		page: 'product:display'
	};
};
